<template>
    <div>
        <div   style="margin-top:2px;display:flex">
            <div style="width:350px;border-right:1px solid #389;" > 
                <div   style=" text-align:center;line-height:28px;border-bottom:1px solid #389;background:white ">
                    <el-checkbox label="含离职" @change="empList" true-label="Y" false-label="N" v-model="v_stfg"></el-checkbox>
                    <el-link :underline="false" @click="prevMth" style="margin-right:10px;margin-left:20px">
                        <i class="iconfont icon-zuoshuangjiantou" style="font-size:12px; font-weight:700;color:#409eff "> </i>
                    </el-link>
                    <el-date-picker :clearable="false" v-model="v_mth" size="mini" style="width:110px;height:15px; margin-top:-5px" @change="changeDate" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>           
                    <el-link :underline="false" @click="nextMth" style="margin-left:10px">
                        <i class="iconfont icon-shuangjiantou" style="font-size:12px; font-weight:700;color:#409eff "> </i>
                    </el-link>
                </div>
                <el-table  :data="tabData" 
                    border                            
                    size="small"
                    ref="refemp"
                    :header-cell-style="{'height':'20px'}"
                    :cell-style="{padding:'2px'}"
                    :height="tabHeight" 
                    @row-click="tabClick"
                    class="custom-table-border"
                    highlight-current-row >  
                    <el-table-column label="序号" type="index" width="55"></el-table-column>
                    <el-table-column  v-for="(item ) in mainCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
    
                    </el-table-column>  
                </el-table> 
            </div>
            <div style=" border-top:1px solid #389;width:99%;height:92vh;margin-right:2px"  >
                <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px">
                    <div style="width:55px;padding-left:2px; border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">开始时间</div>
                    <div style="width:55px;padding-left:2px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">结束时间</div>
                    <div style="width:64%;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">工作内容</div>
                    <div style="width:90px;padding-left:5px;border-right:1px solid #ccc;color:#567;font-size:11px;font-weight:600">关联任务单号</div>
                    <div  style="width:140px;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600; ">任务名称</div>
                    <div  style="width:15%;padding-left:5px;border-right:1px solid #ccc;;color:#567;font-size:11px;font-weight:600">备注</div>
                </div>
                <div style="overflow-y:auto;height:95%; margin-right:2px;background:white ">
                    <span v-for="(item,index) in timeArr " :key="index" >
                        <div >
                            <div style="line-height:30px;height:30px;background:#ccc; padding-left:6px;margin-bottom:6px;margin-right:2px">
                                <span style="font-size:12px;font-weight:700;color:#389;"> 工作日期：{{item.DAYDTTM}}【{{item.WEEK}}】 </span>
                            </div>
                            <span v-for="(subitem,subindex) in dayArr.filter(it=>it['IDSEQ']==item['IDSEQ']) " :key="subindex" >
                                <div style="display:flex;line-height:28px;border-bottom:1px dashed #ccc;font-size:11px;margin-right:2px">
                                    <div style="width:55px;padding-left:5px; border-right:1px solid #ccc">{{subitem['FRTIME']}}</div>
                                    <div style="width:55px;padding-left:5px;border-right:1px solid #ccc">{{subitem['TOTIME']}}</div>
                                    <div :title="subitem['TITLE']" style="width:64%;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['TITLE']}}</div>
                                    <div style="width:90px;padding-left:5px;border-right:1px solid #ccc">{{subitem['REFWKNO']}}</div>
                                    <div :title="subitem['JOBDESC']" style="width:140px;padding-left:5px;border-right:1px solid #ccc;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['JOBDESC']}}</div>
                                    <div :title="subitem['RMK']" style="width:15%;padding-left:5px;border-right:1px solid #ccc; white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{subitem['RMK']}}</div>
                                </div>
                            </span>
                        </div>
                    </span>
                </div>
            </div>
        </div>
 
        <!-- 日历事项 -->
        <el-dialog :show-close="false" :visible.sync="dayWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 工作日志  </span>
            </div> 
            <div style="display:flex; height:35px;margin-bottom:6px">
                <div style="line-height:30px;height:30px;font-size:12px;width:90px">当前选中日期</div>

                <span style="font-weight:600;font-size:12px;line-height:30px;color:#389">{{v_dttm}}</span>
                <div style="line-height:30px;height:30px;font-size:12px;width:90px;margin-left:20px; ">当前用户名称</div>
                <span style="font-weight:600;font-size:12px;line-height:30px;color:#389">{{v_usernm}}</span>
            </div>
            <div class="one-toolbar">
                <span class="spanRow"> 基础信息 </span>
            </div>        
            <Form :model="mainRow" :label-width="120"   label-position="right" inline  >  
                <span v-for="(item,index) in mainCol" :key="index" >
                    <FormItem   :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">                  
                        <template slot="label" > {{item.title}}</template>
                        <el-date-picker size="small" :disabled="saveFlag " type="date"  v-if="item.edcss==='date'" v-model="mainRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                        <el-input size="small" type="text" v-else :disabled="item.disabled==='Y'?true:false||saveFlag "  v-model="mainRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
  
        </el-dialog>
 
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
    </div>
</template>
<script>
 
    import { getTabColOrData,getBaseData } from '../../api/user'
    import {getDate} from '../../api/Select' 
    export default {
        name:"log_query",
        data() {
            return {
                timeArr:[],
                tabData:[],
         
                promptWin:false,
                prompt:'',
                v_stfg:'N',
                saveFlag:true,
                rmkArr:[],
 
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url:'xuper_auth/getTableRecMany',
                
                v_mth:'',
                v_dttm:'',
                v_admin:this.$cookies.get('v_admin') ,//api 请求密码
                dayWin:false,
                v_empno:'',
                mainCol:[],
                dtlCol:[],
                dtlData:[],
                mainRow:{},
                v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
                delDtlArr:[],
                chkIndex: 0,
 
                imgData:[],
                fileName:'',
                delImg:[],
                v_table:'',
                tableCol :[],
                v_key2 :'',
                v_value2 :'',
                btnWin:false,
                v_key:'',
         
 
                dayArr:[],
            }
        },
        created () {
            if (this.v_username){ 
 
                this.v_mth =getDate('month')
                this.empList() //初始化 
                this.getTabField()

            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        components: {
  
        },
        computed:{
            tabHeight: function() {
                return (window.innerHeight - 115) + 'px';
            }, 
            tabWidth: function() {
                return (window.innerWidth - 200) + 'px';
            }, 
            divWidth: function() {
                return (window.innerWidth - 350) + 'px';
            }, 
            selWidth: function() {
                return (window.innerWidth - 220) + 'px';
            },
        },
        methods: {
            nextMth(){
                var starttime= this.$moment(this.v_mth+'-01').startOf('month').subtract('month', -1).format('YYYY-MM-DD') //下个月初
                this.returnDate(starttime)
            },
            prevMth(){
                var starttime= this.$moment(this.v_mth+'-01').startOf('month').subtract('month', 1).format('YYYY-MM-DD') //下个月初
                this.returnDate(starttime)
            },
            empList(){
                this.dayArr =[]
                this.timeArr=[]
                let v_cond =''
                if (this.v_stfg =='N'){
                    v_cond =' and stfg=\'Y\' '
                }
                if (this.v_admin!=='Y'){
                    v_cond =' and telno=\''+this.v_username+'\' '
                }
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'corpid', p_value:this.v_corpid,p_key2:'islog', p_value2:'Y',p_cond:v_cond+ ' order by idno' ,p_table:'V_hr_emp'},
                }).then(res=>{
                    this.tabData =res.result
                    if (this.tabData.length>0){
                        this.$refs['refemp'].setCurrentRow(this.tabData[0])
                        this.v_empno=this.tabData[0]['TELNO']
                        this.dayList(this.tabData[0]['TELNO'])
                    }
                })
            },
 
            //月份日志明细
            dayList(v_userno){
                this.timeArr=[]
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'userno', p_value: v_userno,p_key2:'yrmth', p_value2:this.v_mth,p_cond:' and ty=\'WORK\' AND corpid='+this.v_corpid+' order by Tdttm' ,p_table:'V_hr_msg'},
                }).then(res=>{
                    if (res.code=='200'){
                        this.timeArr =res.result                          
                        getTabColOrData(this.v_url,'V_hr_msgdtl','corpid',this.v_corpid,'userno',v_userno,'YRMTH',this.v_mth,' order by LSTSEQ').then((res) => {               
                            if (res.code=='200'){
                                this.dayArr =res.result         
                            }else{
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })   
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }         
                })
            },
            //变更月份
            returnDate(val){
                let dateArr =val.split('-') 
                this.v_mth =this.$moment(dateArr[0]+'-'+dateArr[1]).format('YYYY-MM')
                this.changeDate(this.v_mth)
            },
            //改变月份
            changeDate(){
                this.dayList(this.v_empno)
            },
 
            // 表记录点击
            tabClick(row){
                this.v_empno =row['TELNO']
                this.dayList(row['TELNO'])
            },
            //获取表列字段
            getTabField(){
                let vm =this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','416884','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.mainCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            dotnum:res.result[k].DOTNUM,
                            sortable:res.result[k].SORTABLE,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','101','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.dtlCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            dotnum:res.result[k].DOTNUM,
                            sortable:res.result[k].SORTABLE,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
 
            }
        },
  }
</script>
 
<style scoped lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .obj{
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 9;
        font-size: 12px;
        display:flex;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        min-width:200px;
    }
 
</style>